import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {RegioverantwoordelijkenComponent} from './regioverantwoordelijken/regioverantwoordelijken.component';
import {UpsertRegioverantwoordelijkeComponent} from './upsert-regioverantwoordelijke/upsert-regioverantwoordelijke.component';

@NgModule({
  declarations: [
    RegioverantwoordelijkenComponent,
    UpsertRegioverantwoordelijkeComponent,
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    RegioverantwoordelijkenComponent,
    UpsertRegioverantwoordelijkeComponent,
  ],
})
export class RegioverantwoordelijkeModule {
}
